import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SizerComponent } from './sizer.component';



@NgModule({
  declarations: [
    SizerComponent
  ],
  imports: [
    CommonModule
  ],
  exports: [
    SizerComponent
  ]
})
export class SizerModule { }
